<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p class="display-2 text-center font-weight-bold indigo--text">I Don’t Know What to Say</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" class="pa-2" align="center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/UmlKehVQBjw"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <v-container style="width:680px">
          <p class="text-sm-left font-weight-bold">I don’t know what to say: Gregory & Anna Rose</p>
          <p
            class="text-sm-left"
          >The first thing I noticed when I first met Greg was the conviction with which he spoke, using larger than life hand gestures/body language to emphasise the words. From Kenya, Greg speaks candidly of his interactions with his family upon returning home.</p>
          <p
            class="text-sm-left"
          >Quite similarly, Anna Rose has a vibrant, infectious energy that never fails to fill a room. Having an interest in the Performing Arts, Literature and Linguistics, I was eager to see just how she would respond to a story told in an unfamiliar language.</p>
          <p class="text-sm-left">Greg speaks English and, Kiswahili. Anna Rose speaks English.</p>
          <p class="text-sm-left">This is Gregory's story told by the both of them.</p>
        </v-container>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/VWZXbFlbCHc"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <v-container style="width:680px">
          <p class="text-sm-left font-weight-bold">I don't know what to say: Grandfather & Alyssa</p>
          <p
            class="text-sm-left"
          >Deciding to move away from home to the U.S. was one that spanned several years. It was something that caused tension between my grandfather and I, something that we are still both trying to reconcile. He feared the uncertainty - would I come home? Where would home be for me? And whilst I was sure that I would come home, moving away only made this resolution clearer for me. I had this newfound connection to Malaysia: I felt the need to keep up to date, to maintain my connection to home.</p>
          <p
            class="text-sm-left"
          >In light of recent political events, I found myself feeling more vulnerable than ever - would my fate be decided for me? A text conversation with my grandfather (shown in this video) highlights these worries: that the home I always thought would be there, the home I took for granted, may not hold a future for me. This video delves into my relationship with my grandfather, the concerns I have, and the hope our people have. It is only fitting my grandfather spoke in Cantonese - a language I only began understanding a few years back...</p>
          <p
            class="text-sm-left"
          >My grandfather speaks Cantonese, English, Mandarin and Malay. I speak English, Malay, Mandarin, Hokkien, and Cantonese (well a little anyways).</p>
          <p class="text-sm-left">This is our story told through the two of us.</p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>